import { TextFieldTheme } from '@wix/wix-ui-tpa/cssVars';
import React, { useCallback, useState } from 'react';
import { useFieldAttributes } from '../../services/field-attributes';
import { AutocompleteWUT } from '../autocomplete/autocomplete-wut';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { useInvokeCallback } from '../shared/use-invoke-callback';
export const DropdownAutocompleteWUT = _ref => {
  let {
    id,
    target,
    options,
    placeholder,
    required,
    hideLabel,
    value,
    disabled,
    description,
    hasError = false,
    errorMessage,
    error,
    label,
    onChange,
    onBlur,
    onFocus,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const [inputValue, setInputValue] = useState(() => resolveLabel(options, value));
  const invokeBlur = useInvokeCallback(onBlur);
  const handleBrowserAutofill = useCallback(currentInputValue => {
    const matchingOption = findMatchingOption(options, currentInputValue);
    if (matchingOption) {
      const newValue = String(matchingOption.id);
      onChange == null || onChange(newValue);
    }
  }, [onChange, options]);
  const handleChange = useCallback(event => {
    handleBrowserAutofill(event.target.value);
    setInputValue(event.target.value);
  }, [setInputValue, handleBrowserAutofill]);
  const handleSelect = useCallback(option => {
    const newValue = option.id;
    setInputValue(option.value);
    onChange(newValue);
  }, [onChange, setInputValue]);
  const handleBlur = useCallback(() => {
    const currentLabel = resolveLabel(options, value);
    setInputValue(currentLabel);
    invokeBlur();
  }, [invokeBlur, value, options]);
  const handleManualInput = useCallback(() => {
    const matchingOption = findMatchingOption(options, inputValue);
    if (matchingOption) {
      const newValue = String(matchingOption.id);
      onChange == null || onChange(newValue);
      setInputValue(matchingOption.value);
    }
    if (!inputValue) {
      onChange == null || onChange('');
      setInputValue('');
    }
  }, [options, inputValue, onChange]);
  const handleInitialSelectedOptionsSet = useCallback(() => {
    const currentLabel = resolveLabel(options, value);
    setInputValue(currentLabel);
  }, [options, value]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(AutocompleteWUT, {
      id: inputId,
      value: inputValue,
      options: options,
      disabled: disabled,
      showArrow: true,
      placeholder: placeholder,
      error: hasError,
      initialSelectedId: value ?? undefined,
      onInitialSelectedOptionsSet: handleInitialSelectedOptionsSet,
      onChange: handleChange,
      onSelect: handleSelect,
      onManualInput: handleManualInput,
      onBlur: handleBlur,
      onFocus: onFocus,
      ariaDescribedBy: ariaDescribedBy,
      theme: TextFieldTheme.Box
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
function resolveLabel(options, value) {
  var _options$find;
  if (!value) {
    return '';
  }
  return ((_options$find = options.find(option => option.id === value)) == null ? void 0 : _options$find.value) ?? '';
}
function findMatchingOption(options, label) {
  return options.find(option => option.value.toLocaleLowerCase() === label.toLocaleLowerCase().trim());
}
//# sourceMappingURL=dropdown-autocomplete-wut.js.map